// ============================================
// MAIN APPLICATION COMPONENT
// ============================================

import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store';
import { ProtectedRoute } from './components/auth';
import { 
  LoginPage, 
  VerifyOtpPage, 
  IntroPage, 
  FormPage, 
  SuccessPage, 
  FailurePage,
  TermsPage,
  PrivacyPage,
} from './pages';
import { ROUTES } from './constants';
import './App.css';

function App() {
  const { initialize, isLoading, isAuthenticated } = useAuthStore();

  useEffect(() => {
    initialize();
  }, [initialize]);

  // Only show loading if we're checking auth AND not on a public route
  // This prevents flash during navigation to verify-otp
  if (isLoading && !isAuthenticated) {
    // Check if we're on a public route
    const publicPaths = ['/login', '/verify-otp', '/terms', '/privacy'];
    const isPublicRoute = publicPaths.some(path => window.location.pathname.startsWith(path));
    
    if (!isPublicRoute) {
      return (
        <div className="app-loading">
          <div className="app-loading-spinner" />
          <span>Loading...</span>
        </div>
      );
    }
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.VERIFY_OTP} element={<VerifyOtpPage />} />
        <Route path={ROUTES.TERMS} element={<TermsPage />} />
        <Route path={ROUTES.PRIVACY} element={<PrivacyPage />} />
        
        {/* Protected Routes */}
        <Route
          path={ROUTES.INTRO}
          element={
            <ProtectedRoute>
              <IntroPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.FORM}
          element={
            <ProtectedRoute>
              <FormPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.SUCCESS}
          element={
            <ProtectedRoute>
              <SuccessPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.FAILURE}
          element={
            <ProtectedRoute>
              <FailurePage />
            </ProtectedRoute>
          }
        />

        {/* Default Redirect */}
        <Route path={ROUTES.HOME} element={<Navigate to={ROUTES.LOGIN} replace />} />
        <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
